import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import "./index.css"; 

interface SuccessMessageProps {
  isError: boolean;
  onRetry: () => void;
  onFinish: () => void; // Add the onFinish prop
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ isError, onRetry, onFinish }) => {
  return (
    <div className="success-message-container">
      <div className="message-content">
        <div className={`message-icon ${isError ? "error" : "success"}`}>
          <FontAwesomeIcon icon={isError ? faTimes : faCheck} className={`message-inside-icon ${isError ? "error" : "success"}`}/>
        </div>
        <h2>{isError ? "Error!" : "Success!"}</h2>
        <p>{isError ? "Cart Created Not Successfully!" : "Cart Created Successfully!"}</p>
        {isError ? (
          <Button onClick={onRetry} className="retry-button">Try again</Button>
        ) : (
          <Button onClick={onFinish} className="finish-button">Finish</Button>
        )}
      </div>
    </div>
  );
};

export default SuccessMessage;